<template>
  <div>
    <Sidebar
      class="p-sidebar-md so-sidebar"
      :dismissable="true"
      position="right"
      :visible.sync="localShowSidebar"
      @hide="close"
      :style="{ width: '420px' }"
    >
      <div class="so-sidebar-header p-mb-3">
        <h3><i class="pi pi-wrench p-mr-2"></i>Ordens de Serviço</h3>
      </div>

      <div v-if="loading" class="p-d-flex p-ai-center p-jc-center" style="height: 200px">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
      </div>

      <div v-else class="so-content">
        <!-- LG Section -->
        <div class="so-brand-section p-mb-3">
          <div class="so-brand-header p-d-flex p-ai-center p-jc-between p-mb-2">
            <span class="so-brand-title">LG</span>
            <Button
              label="Ver lista"
              class="p-button-sm p-button-text"
              icon="pi pi-external-link"
              @click="goTo('/serviceOrders/lg')"
            />
          </div>
          <div class="p-d-flex p-jc-start" style="gap: 12px;">
            <div class="so-indicator-card" :class="{ 'so-indicator-alert': lgSemPat > 0 }">
              <span class="so-indicator-count">{{ lgSemPat }}</span>
              <span class="so-indicator-label">Sem PAT</span>
            </div>
            <div class="so-indicator-card" :class="{ 'so-indicator-alert': lgPorAceitar > 0 }">
              <span class="so-indicator-count">{{ lgPorAceitar }}</span>
              <span class="so-indicator-label">Por Aceitar</span>
            </div>
          </div>
        </div>

        <!-- Hisense Section -->
        <div class="so-brand-section p-mb-3">
          <div class="so-brand-header p-d-flex p-ai-center p-jc-between p-mb-2">
            <span class="so-brand-title">Hisense</span>
            <Button
              label="Ver lista"
              class="p-button-sm p-button-text"
              icon="pi pi-external-link"
              @click="goTo('/serviceOrders/hisense')"
            />
          </div>
          <div class="p-d-flex p-jc-start" style="gap: 12px;">
            <div class="so-indicator-card" :class="{ 'so-indicator-alert': hisenseSemPat > 0 }">
              <span class="so-indicator-count">{{ hisenseSemPat }}</span>
              <span class="so-indicator-label">Sem PAT</span>
            </div>
            <div class="so-indicator-card" :class="{ 'so-indicator-alert': hisensePorAceitar > 0 }">
              <span class="so-indicator-count">{{ hisensePorAceitar }}</span>
              <span class="so-indicator-label">Por Aceitar</span>
            </div>
          </div>
        </div>

        <!-- Domestic & General Section -->
        <div class="so-brand-section">
          <div class="so-brand-header p-d-flex p-ai-center p-jc-between p-mb-2">
            <span class="so-brand-title">Domestic &amp; General</span>
            <Button
              label="Ver lista"
              class="p-button-sm p-button-text"
              icon="pi pi-external-link"
              @click="goTo('/serviceOrders/dg')"
            />
          </div>
          <div class="p-d-flex p-jc-start" style="gap: 12px;">
            <div class="so-indicator-card" :class="{ 'so-indicator-alert': dgSemPat > 0 }">
              <span class="so-indicator-count">{{ dgSemPat }}</span>
              <span class="so-indicator-label">Sem PAT</span>
            </div>
          </div>
        </div>
      </div>
    </Sidebar>
  </div>
</template>

<script>
import Sidebar from 'primevue/sidebar';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'SidebarServiceOrdersIndicator',
  components: { Sidebar },
  data() {
    return {
      loading: false,
      localShowSidebar: false,
    };
  },
  computed: {
    ...mapGetters('serviceOrdersIndicator', [
      'showSidebar',
      'lgSemPat',
      'lgPorAceitar',
      'hisenseSemPat',
      'hisensePorAceitar',
      'dgSemPat',
      'dgPorAceitar',
    ]),
  },
  watch: {
    showSidebar(newVal) {
      this.localShowSidebar = newVal;
      if (newVal) {
        this.refresh();
      }
    },
  },
  methods: {
    ...mapActions('serviceOrdersIndicator', ['fetchCounts', 'toggleSidebar']),
    close() {
      this.toggleSidebar(false);
    },
    async refresh() {
      this.loading = true;
      await this.fetchCounts();
      this.loading = false;
    },
    goTo(path) {
      this.$router.push(path).catch(() => {});
      this.close();
    },
  },
};
</script>

<style scoped>
.so-sidebar-header {
  padding: 1.5rem 1.5rem 1rem 1.5rem;
  border-bottom: 1px solid #e0e0e0;
}

.so-content {
  padding: 1.25rem 1.5rem;
}

.so-brand-section {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1rem;
}

.so-brand-header {
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 0.5rem;
}

.so-brand-title {
  font-size: 1rem;
  font-weight: 700;
  color: #334155;
}

.so-indicator-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 90px;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
}

.so-indicator-alert {
  border-color: #f59e0b;
  background: #fffbeb;
}

.so-indicator-count {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1;
}

.so-indicator-alert .so-indicator-count {
  color: #b45309;
}

.so-indicator-label {
  font-size: 0.75rem;
  color: #64748b;
  margin-top: 4px;
  white-space: nowrap;
}
</style>
